<form [formGroup]="formGroup" [bitSubmit]="submit" bit-dialog class="bv-import-confirm-dialog">
  <span bitDialogTitle>{{ "confirmVaultImport" | i18n }}</span>

  <div bitDialogContent>
    <p class="bv-import-dialog__message">{{ "confirmVaultImportDesc" | i18n }}</p>
    <bit-form-field class="bv-import-dialog__password-field">
      <bit-label>{{ "confirmFilePassword" | i18n }}</bit-label>
      <input
        bitInput
        type="password"
        formControlName="filePassword"
        appAutofocus
        appInputVerbatim
      />
      <button type="button" bitSuffix bitIconButton bitPasswordInputToggle></button>
    </bit-form-field>
  </div>

  <ng-container bitDialogFooter>
    <div class="bv-import-dialog__footer">
      <button bitButton bitDialogClose buttonType="secondary" type="button">
        {{ "cancel" | i18n }}
      </button>
      <button bitButton buttonType="primary" type="submit">
        {{ "importVault" | i18n }}
      </button>
    </div>
  </ng-container>
</form>
